// شعار الشركة أعلى التقارير المطبوعة: الشعار وحده في أحد الجوانب بلا أي نص بجانبه.
import { esc } from "./reportFormat";

export const brandLogo = (brand) =>
  brand?.logo ? `<img class="brand-logo" src="${esc(brand.logo)}" alt="" />` : "";

export const brandName = (brand) =>
  brand?.name ? `<div class="brand-name">${esc(brand.name)}</div>` : "";

// يحوّل رابط الشعار إلى data URL حتى يظهر داخل نافذة الطباعة بلا مصادقة.
export const brandOf = async (company, lang, toDataUrl) => {
  if (!company) return null;
  const name = (lang === "en" ? company.name : company.name_ar) || company.name || company.name_ar;
  return {
    name,
    logo: company.logo_url ? await toDataUrl(company.logo_url) : null,
  };
};
